export interface IProps {
    onClose(): void;
    onSuccess?(): void;
}

export enum EAction {
    CREATE = 'create',
};
